import { Box, Container, Heading, Stack, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import img1 from '../assets/1.jpg';
import img2 from '../assets/2.jpg';
import img3 from '../assets/3.jpg';
import img4 from '../assets/4.jpg';
import img5 from '../assets/5.png';
import img6 from '../assets/6.jpg';
import img7 from '../assets/7.jpg';
import img8 from '../assets/8.jpg';
import img9 from '../assets/9.jpg';
import img10 from '../assets/10.jpg';
import img11 from '../assets/11.jpg';

const headingOptions = {
  pos: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%,-50%)',
  textTransform: 'uppercase',
  p: '4',
  size: '3xl',
};
const Home = () => {
  return (
    <Box>
      <MyCarousel />
      <Container maxW={'container.xl'} minH={'100vh'} p="16">
        <Heading
          textTransform={'uppercase'}
          py="2"
          w={'fit-content'}
          borderBottom={'2px solid'}
          m="auto"
        >
          Services
        </Heading>
        <Stack
          h={'full'}
          p={'4'}
          alignItems={'center'}
          direction={['column', 'row']}
        >
          <Image src={img5} h={['40', '400']} filter={'hue-rotate(-130deg)'} />
          <Text
            letterSpacing={'widest'}
            lineHeight={'190%'}
            p={['4', '16']}
            textAlign={'center'}
          >
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Assumenda
            numquam alias ea molestiae. Laboriosam consectetur sapiente
            doloremque consequatur delectus, corrupti inventore tenetur ipsa
            illo id accusamus unde vitae deserunt nisi?
          </Text>
        </Stack>
      </Container>
    </Box>
  );
};

const MyCarousel = () => (
  <Carousel
    autoPlay
    infiniteLoop
    interval={1000}
    showStatus={false}
    showThumbs={false}
    showArrows={false}
  >
    <Box w="full" h={'100vh'}>
      <img src={img4} />
      <Heading bgColor={'whiteAlpha.600'} color={'black'} {...headingOptions}>
        Watch The Future
      </Heading>
    </Box>

    <Box w="full" h={'100vh'}>
      <img src={img3} />
      <Heading bgColor={'whiteAlpha.600'} color={'black'} {...headingOptions}>
        gaming is future{' '}
      </Heading>
    </Box>

    <Box w="full" h={'100vh'}>
      <img src={img1} />
      <Heading bgColor={'whiteAlpha.600'} color={'black'} {...headingOptions}>
        Hackers future
      </Heading>
    </Box>

    <Box w="full" h={'100vh'}>
      <img src={img6} />
      <Heading bgColor={'whiteAlpha.600'} color={'black'} {...headingOptions}>
        Something else
      </Heading>
    </Box>
    <Box w="full" h={'100vh'}>
      <img src={img7} />
      <Heading bgColor={'whiteAlpha.600'} color={'black'} {...headingOptions}>
        Alian Technology
      </Heading>
    </Box>
    <Box w="full" h={'100vh'}>
      <img src={img8} />
      <Heading bgColor={'whiteAlpha.600'} color={'black'} {...headingOptions}>
        Robots Is Fututre
      </Heading>
    </Box>
    <Box w="full" h={'100vh'}>
      <img src={img9} />
      <Heading bgColor={'whiteAlpha.600'} color={'black'} {...headingOptions}>
        Ai Robots
      </Heading>
    </Box>
    <Box w="full" h={'100vh'}>
      <img src={img10} />
      <Heading bgColor={'whiteAlpha.600'} color={'black'} {...headingOptions}>
        VR is The Fututre
      </Heading>
    </Box>
    <Box w="full" h={'100vh'}>
      <img src={img11} />
      <Heading bgColor={'whiteAlpha.600'} color={'black'} {...headingOptions}>
        Ai Based Army{' '}
      </Heading>
    </Box>
  </Carousel>
);

export default Home;
